import React, { useState } from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import CustomNavbarClients from "../navBarClients/CustomNavbarClients";
import ClientMenuBar from "../ClientMenuBar";
import Footer from "../Footer";
import "./FAQ.scss";

const FAQ: React.FC = () => {
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  const toggleAccordion = (key: string) => {
    setActiveKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const faqData = [
    {
      id: "1",
      category: "Productos y Tallas",
      questions: [
        {
          question: "¿Cómo puedo saber qué talla elegir?",
          answer:
            "En cada producto encontrarás una guía de tallas específica. Te recomendamos medir tu cuerpo y comparar con nuestras tablas de medidas. Si tienes dudas, puedes contactarnos por WhatsApp al 868 265 3942 y nuestro equipo te ayudará a elegir la talla correcta.",
        },
        {
          question:
            "¿Los colores de los productos son exactos a los de las fotos?",
          answer:
            "Hacemos nuestro mejor esfuerzo para que las fotos representen fielmente los colores reales de los productos. Sin embargo, los colores pueden variar ligeramente debido a la configuración de pantalla de tu dispositivo. Si tienes dudas sobre un color específico, no dudes en contactarnos.",
        },
        {
          question: "¿Tienen productos en tallas grandes?",
          answer:
            "Sí, manejamos una amplia variedad de tallas. La disponibilidad depende de cada producto específico. Puedes filtrar por talla en nuestra sección de búsqueda o contactarnos para consultar disponibilidad de tallas específicas.",
        },
        {
          question: "¿Con qué frecuencia llegan productos nuevos?",
          answer:
            "Recibimos productos nuevos semanalmente. Te recomendamos seguirnos en nuestras redes sociales y suscribirte a nuestro newsletter para estar al día con las últimas novedades y lanzamientos exclusivos.",
        },
      ],
    },
    {
      id: "2",
      category: "Compras y Pagos",
      questions: [
        {
          question: "¿Qué métodos de pago aceptan?",

          answer:
            "Aceptamos pagos a través de PayPal, que te permite pagar de forma segura con tu cuenta PayPal o directamente con tus tarjetas de crédito y débito (Visa, Mastercard, American Express) sin necesidad de tener una cuenta PayPal. Todas las transacciones son procesadas de forma segura por PayPal, garantizando la protección de tus datos financieros.",
        },
        {
          question: "¿Es seguro comprar en línea en su sitio web?",

          answer:
            "Absolutamente. Utilizamos PayPal como nuestro procesador de pagos oficial, que cuenta con las más altas certificaciones de seguridad a nivel mundial. PayPal encripta toda la información financiera y no compartimos ningún dato de tus tarjetas con terceros. Además, PayPal ofrece protección al comprador en cada transacción.",
        },
        {
          question: "¿Puedo cancelar mi pedido después de haberlo realizado?",
          answer:
            "Puedes cancelar tu pedido únicamente antes de que sea procesado y enviado. Una vez que el pedido está en tránsito, no es posible cancelarlo debido a nuestra política de ventas finales. Contacta inmediatamente a nuestro servicio al cliente si necesitas cancelar.",
        },
        {
          question: "¿Puedo comprar sin crear una cuenta?",
          answer:
            "No, es necesario crear una cuenta para realizar compras en nuestro sitio web. El registro es rápido y sencillo, solo necesitas tu nombre, correo electrónico y crear una contraseña segura. También puedes registrarte rápidamente usando tu cuenta de Google. Una vez registrado, tendrás acceso a tu historial de compras, seguimiento de pedidos, lista de deseos y ofertas exclusivas para miembros.",
        },
        {
          question: "¿Necesito tener una cuenta PayPal para comprar?",
          answer:
            "No es necesario tener una cuenta PayPal. Durante el proceso de pago, PayPal te dará la opción de pagar directamente con tu tarjeta de crédito o débito como invitado, o bien puedes usar tu cuenta PayPal existente si tienes una. Ambas opciones son igual de seguras.",
        },
        {
          question: "¿Qué pasa si hay un problema con mi pago?",
          answer:
            "Si experimentas algún problema durante el proceso de pago, PayPal te notificará inmediatamente. En caso de que el pago no se procese correctamente, tu dinero no será debitado. Si el pago se realiza pero tienes algún inconveniente, puedes contactarnos directamente o utilizar el sistema de resolución de disputas de PayPal.",
        },
      ],
    },
    {
      id: "3",
      category: "Envíos y Entregas",
      questions: [
        {
          question: "¿A dónde realizan envíos?",
          answer:
            "Realizamos envíos a toda la República Mexicana. Los tiempos y costos de envío varían según la ubicación. Durante el proceso de compra podrás ver el costo exacto de envío a tu código postal antes de confirmar el pedido.",
        },
        {
          question: "¿Cuánto tiempo tarda en llegar mi pedido?",
          answer:
            "Los tiempos de entrega varían según tu ubicación: \n• Matamoros y área metropolitana: 1-2 días hábiles\n• Tamaulipas: 2-3 días hábiles\n• Norte del país: 3-5 días hábiles\n• Centro y Sur: 5-7 días hábiles\n\nEstos tiempos pueden verse afectados por condiciones climáticas o situaciones extraordinarias.",
        },
        {
          question: "¿Cuánto cuesta el envío?",
          answer:
            "El costo de envío se calcula automáticamente según el peso del paquete y la distancia. Generalmente oscila entre $50 y $150 pesos. Durante el checkout podrás ver el costo exacto antes de confirmar tu compra. Ocasionalmente ofrecemos promociones de envío gratis.",
        },
        {
          question: "¿Puedo rastrear mi pedido?",
          answer:
            "Sí, una vez que tu pedido sea enviado, recibirás un correo electrónico con el número de seguimiento y el enlace para rastrear tu paquete en tiempo real a través de la paquetería correspondiente.",
        },
        {
          question: "¿Qué pasa si no estoy en casa cuando llegue mi pedido?",
          answer:
            "La paquetería intentará entregarte el pedido hasta 3 veces. Si no te encuentran, dejarán un aviso de entrega. También puedes coordinar directamente con la paquetería para reprogramar la entrega o recoger tu paquete en la sucursal más cercana.",
        },
      ],
    },
    {
      id: "4",
      category: "Política de Ventas",
      questions: [
        {
          question: "¿Aceptan devoluciones o cambios?",
          answer:
            "NO, todas nuestras ventas son finales. No aceptamos devoluciones, cambios ni reembolsos una vez completada la compra. Te recomendamos revisar cuidadosamente tallas, colores y descripciones antes de comprar. Si tienes dudas, contáctanos antes de realizar tu pedido.",
        },
        {
          question: "¿Qué pasa si el producto llega defectuoso o dañado?",
          answer:
            "En el caso excepcional de que tu producto llegue defectuoso o dañado durante el envío, contáctanos inmediatamente (máximo 24 horas después de recibir el producto) con fotos del daño. Evaluaremos cada caso individualmente para encontrar una solución adecuada.",
        },
        {
          question: "¿Por qué no aceptan devoluciones?",
          answer:
            "Esta política nos permite ofrecer precios más competitivos y mantener la calidad e higiene de nuestros productos. Por razones de salud pública y control de calidad, especialmente en productos de vestir, hemos implementado esta política de ventas finales.",
        },
      ],
    },
    {
      id: "5",
      category: "Cuenta y Perfil",
      questions: [
        {
          question: "¿Cómo creo una cuenta?",
          answer:
            "Para realizar compras en Nallely Boutique, debes crear una cuenta primero. El proceso es muy fácil: haz clic en 'Iniciar Sesión' y luego en 'Registrarse'. Solo necesitas proporcionar tu nombre completo, correo electrónico y crear una contraseña segura. También puedes registrarte rápidamente usando tu cuenta de Google para mayor comodidad.",
        },
        {
          question: "¿Olvidé mi contraseña, qué puedo hacer?",
          answer:
            "En la página de inicio de sesión, haz clic en '¿Olvidaste tu contraseña?' e ingresa tu correo electrónico. Te enviaremos un código de verificación para restablecer tu contraseña de forma segura.",
        },
        {
          question: "¿Puedo cambiar mi información personal?",
          answer:
            "Sí, una vez que hayas iniciado sesión, puedes acceder a tu perfil y actualizar tu información personal, direcciones de entrega y preferencias. Los cambios se guardan automáticamente.",
        },
        {
          question: "¿Cómo funciona la lista de deseos?",
          answer:
            "Cuando encuentres un producto que te guste, haz clic en el corazón para agregarlo a tu lista de deseos. Puedes acceder a todos tus productos guardados desde tu perfil y añadirlos fácilmente al carrito cuando desees comprarlos.",
        },
        {
          question: "¿Por qué necesito crear una cuenta para comprar?",
          answer:
            "Requerimos que crees una cuenta para brindarte un mejor servicio y seguridad. Esto nos permite: gestionar tus pedidos de manera más eficiente, enviarte actualizaciones sobre el estado de tu compra, mantener un historial de tus compras para futuras referencias, y ofrecerte una experiencia personalizada con tus productos favoritos y recomendaciones. Además, facilita el proceso de soporte al cliente en caso de que necesites ayuda.",
        },
      ],
    },
    {
      id: "6",
      category: "Promociones y Descuentos",
      questions: [
        {
          question: "¿Cómo me entero de las promociones y ofertas?",
          answer:
            "Puedes mantenerte informado de varias maneras: suscribiéndote a nuestro newsletter, siguiéndonos en Facebook e Instagram, y visitando regularmente nuestra sección de ofertas en el sitio web. Los suscriptores reciben ofertas exclusivas.",
        },
        {
          question: "¿Puedo usar múltiples códigos de descuento?",
          answer:
            "Generalmente solo se puede aplicar un código de descuento por pedido. Sin embargo, algunos descuentos automáticos pueden combinarse con códigos promocionales específicos. El sistema aplicará automáticamente la mejor oferta disponible.",
        },
        {
          question: "¿Los productos en oferta tienen las mismas condiciones?",
          answer:
            "Sí, todos los productos, incluyendo los de oferta, están sujetos a nuestra política de ventas finales y se pagan a través de PayPal. Los descuentos aplicados son definitivos y no se pueden combinar con otras promociones salvo que se especifique lo contrario.",
        },
      ],
    },
    {
      id: "7",
      category: "Contacto y Soporte",
      questions: [
        {
          question: "¿Cómo puedo contactar al servicio al cliente?",
          answer:
            "Puedes contactarnos de varias formas:\n• WhatsApp: 868 265 3942\n• Email: boutique_marte@hotmail.com\n• Teléfono: 868 265 3942\n• Visítanos en tienda: Av Marte R. Gómez 403, Francisco I. Madero, Matamoros, Tamps.\n• Horario: Lunes a Sábado de 10:00 AM a 7:00 PM",
        },
        {
          question: "¿Cuál es el tiempo de respuesta del soporte al cliente?",
          answer:
            "Nos esforzamos por responder a todas las consultas en un máximo de 24 horas durante días hábiles. Para consultas urgentes, te recomendamos contactarnos por WhatsApp donde generalmente respondemos en pocas horas.",
        },
        {
          question: "¿Tienen tienda física?",
          answer:
            "Sí, nuestra tienda física está ubicada en Av Marte R. Gómez 403, Francisco I. Madero, 87395 Heroica Matamoros, Tamaulipas. Nuestro horario es de Lunes a Sábado de 10:00 AM a 7:00 PM. ¡Te esperamos!",
        },
        {
          question: "¿Por qué solo aceptan PayPal?",
          answer:
            "Elegimos PayPal como nuestro procesador de pagos exclusivo porque ofrece la máxima seguridad tanto para nosotros como para nuestros clientes. PayPal permite procesar pagos con tarjetas de crédito y débito sin que tengas que compartir tus datos financieros directamente con nosotros, y además ofrece protección al comprador en todas las transacciones.",
        },
      ],
    },
    {
      id: "8",
      category: "Problemas Técnicos",
      questions: [
        {
          question: "¿Qué hago si el sitio web no carga correctamente?",
          answer:
            "Si experimentas problemas técnicos, intenta: refrescar la página, borrar el caché y cookies de tu navegador, intentar desde otro navegador o dispositivo, o verificar tu conexión a internet. Si el problema persiste, contáctanos con detalles específicos del error.",
        },
        {
          question: "¿Por qué no puedo agregar productos al carrito?",
          answer:
            "Esto puede deberse a: producto agotado, problemas de conexión, o cookies deshabilitadas. Verifica que el producto muestre disponibilidad y que tu navegador permita cookies. Si continúa el problema, contáctanos para asistirte con tu compra.",
        },
        {
          question: "¿El sitio web funciona en dispositivos móviles?",
          answer:
            "Sí, nuestro sitio web está completamente optimizado para dispositivos móviles y tablets. Puedes navegar, buscar productos y realizar compras cómodamente desde cualquier dispositivo con conexión a internet.",
        },
      ],
    },
  ];

  return (
    <>
      <CustomNavbarClients />
      <ClientMenuBar />

      <div className="faq-container">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} lg={10} xl={9}>
              {/* Main Title */}
              <div className="faq-title-section">
                <h1 className="faq-main-title">Preguntas Frecuentes</h1>
                <p className="faq-subtitle">
                  Encuentra respuestas a las dudas más comunes sobre Boutique
                  Marte
                </p>
              </div>

              {/* FAQ Content */}
              <div className="faq-content">
                {faqData.map((category) => (
                  <div key={category.id} className="faq-category">
                    <h2 className="category-title">{category.category}</h2>

                    <Accordion className="faq-accordion" flush>
                      {category.questions.map((item, index) => (
                        <Accordion.Item
                          key={`${category.id}-${index}`}
                          eventKey={`${category.id}-${index}`}
                          className="faq-item"
                        >
                          <Accordion.Header className="faq-question">
                            <span className="question-text">
                              {item.question}
                            </span>
                          </Accordion.Header>
                          <Accordion.Body className="faq-answer">
                            <div className="answer-text">
                              {item.answer
                                .split("\n")
                                .map((line, lineIndex) => (
                                  <p
                                    key={lineIndex}
                                    className="answer-paragraph"
                                  >
                                    {line}
                                  </p>
                                ))}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </div>
                ))}

                {/* Contact Section */}
                <div className="faq-contact-section">
                  <h3 className="contact-title">
                    ¿No encontraste lo que buscabas?
                  </h3>
                  <p className="contact-text">
                    Si tienes alguna pregunta que no está en esta lista, no
                    dudes en contactarnos. Nuestro equipo de atención al cliente
                    estará encantado de ayudarte.
                  </p>
                  <div className="contact-options">
                    <div className="contact-row">
                      <div className="contact-option">
                        <strong>WhatsApp:</strong> 868 265 3942
                      </div>
                      <div className="contact-option">
                        <strong>Email:</strong> boutique_marte@hotmail.com
                      </div>
                    </div>
                    <div className="contact-row">
                      <div className="contact-option">
                        <strong>Horario:</strong> Lunes a Sábado de 10:00 AM a
                        7:00 PM
                      </div>
                      <div className="contact-option">
                        <strong>Visítanos:</strong> Av Marte R. Gómez 403
                        Francisco I. Madero 87395 Heroica Matamoros, Tamps.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default FAQ;
